import { Pipe, PipeTransform } from '@angular/core';
@Pipe({name: 'financialInt'})
export class FinancialIntPipe implements PipeTransform {
  transform(value): string {
    if (!value) return '-';
    else {
        if (value === 0) return '-';
        else if (isNaN(value)) return value;
        else return value.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
}


// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/pipe/finaicial-int.pipe.ts